import { useRouter } from 'next/router'
import { useMasterData } from 'src/api/masterData'
import { withLoginUser } from 'src/api/user'
import { Loading } from 'src/components/Loading'
import { NeedsLayout } from './NeedsLayout'

export const Needs = withLoginUser(({ user }) => {
  const router = useRouter()
  const { data: masterData } = useMasterData()
  if (!router.isReady || !masterData || !user.id)
    return <Loading isLoading={true} />
  return <NeedsLayout user={user} masterData={masterData} />
})
